import { useState, useCallback, useMemo } from "react";

export function useFieldValidation() {
  const [fieldValidationErrors, setFieldValidationErrors] = useState({});

  const handleFieldValidationChange = useCallback((fieldId, hasError) => {
    setFieldValidationErrors((prev) => {
      if (prev[fieldId] === hasError) return prev; // avoid unnecessary re-render
      if (!hasError) {
        const next = { ...prev };
        delete next[fieldId];
        return next;
      }
      return { ...prev, [fieldId]: true };
    });
  }, []);

  const clearFieldError = useCallback((fieldId) => {
    setFieldValidationErrors((prev) => {
      if (!Object.prototype.hasOwnProperty.call(prev, fieldId)) return prev;
      const next = { ...prev };
      delete next[fieldId];
      return next;
    });
  }, []);

  const hasFieldValidationErrors = useMemo(
    () => Object.values(fieldValidationErrors).some(Boolean),
    [fieldValidationErrors],
  );

  return {
    fieldValidationErrors,
    hasFieldValidationErrors,
    handleFieldValidationChange,
    clearFieldError,
  };
}